module.exports = __webpack_public_path__ + "static/media/dominox.939f956b.mp4";